import React, { useState } from 'react'
import Topbar from './Topbar'
import Navbar from './Navbar'
import Footer from './Footer'
import GalleryLogo from '../images/Gallery-img.png'
import '../css/Gallery.css'
import Gallery1 from '../images/Gallery/NewImg1.jpeg'
import Gallery2 from '../images/Gallery/NewImg2.jpeg'
import Gallery3 from '../images/Gallery/NewImg3.jpeg'

const GalleryMain = () => {

    document.title = `हलिं नेवा: गुथि | धुकु`

    const [isGalleryModalOpen, setIsGalleryModalOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState('');

    const galleryList = [
        {
            id: 1,
            galleryName: 'img1',
            galleryImg: Gallery1
        },
        {
            id: 2,
            galleryName: 'img2',
            galleryImg: Gallery2
        },
        {
            id: 3,
            galleryName: 'img3',
            galleryImg: Gallery3
        },
    ]

    const handleImageClick = (image) => {
        setCurrentImage(image);
        setIsGalleryModalOpen(true);
    }

    const closeModal = () => {
        setIsGalleryModalOpen(false);
        setCurrentImage('');
    }

    return (
        <>
            <div className="header-top">
                <Topbar />
            </div>

            <div className="header-navbar">
                <Navbar />
            </div>

            <div className='gallery-head'>
                {/* <h1>Contact Us</h1> */}
                <img src={GalleryLogo} alt="Contact" />
                <h1> / धुकु</h1>
            </div>

            <div className='activities-body'>
                <div className="activities-card-container">
                    {galleryList.map((item, id) => {
                        return (
                            <div className="activities-card">
                                <div className="activities-card-img" key={item.id} onClick={() => handleImageClick(item.galleryImg)}>
                                    <img src={item.galleryImg} alt="gallery-1" />
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>

            {isGalleryModalOpen && (
                <div className='gallerymodal'>
                    <span className='close' onClick={closeModal}>&times;</span>
                    <img className='gallerymodal-content' src={currentImage} alt='fullscreen' />
                </div>
            )}

            <div className="footer-links">
                <Footer />
            </div>

        </>
    )
}

export default GalleryMain